'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Connections store
var getMeasurementsMap = exports.getMeasurementsMap = function getMeasurementsMap(state) {
  return state.get('measurements');
};

// Element's selectors
var getMeasurementsMapFromProps = exports.getMeasurementsMapFromProps = function getMeasurementsMapFromProps(state, ownProps) {
  return ownProps.measurements;
};
var getElementMeasurments = exports.getElementMeasurments = function getElementMeasurments(state, _ref) {
  var id = _ref.id;
  return getMeasurementsMap(state).get(id);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/measurementsSelector.js
// module id = 124
// module chunks = 0